import { useState, useCallback } from "react";

const useConfirmDialog = () => {
  const [dialogState, setDialogState] = useState({
    open: false,
    loading: false,
    success: false,
    error: null,
    data: null,
  });

  const openDialog = useCallback((data = null) => {
    setDialogState({
      open: true,
      loading: false,
      success: false,
      error: null,
      data,
    });
  }, []);

  const closeDialog = useCallback(() => {
    setDialogState({
      open: false,
      loading: false,
      success: false,
      error: null,
      data: null,
    });
  }, []);

  const setLoading = useCallback((loading) => {
    setDialogState((prev) => ({
      ...prev,
      loading,
      error: null,
    }));
  }, []);

  const setSuccess = useCallback(
    (success = true) => {
      setDialogState((prev) => ({
        ...prev,
        success,
        loading: false,
        error: null,
      }));

      if (success) {
        setTimeout(() => {
          closeDialog();
        }, 1500);
      }
    },
    [closeDialog]
  );

  const setError = useCallback((error) => {
    setDialogState((prev) => ({
      ...prev,
      error,
      loading: false,
      success: false,
    }));
  }, []);

  const executeAction = useCallback(
    async (actionFn) => {
      console.log("executeAction: Setting loading to true");
      setLoading(true);

      // Small delay to ensure state update is visible
      await new Promise((resolve) => setTimeout(resolve, 100));

      try {
        console.log("executeAction: Calling action function");
        const result = await actionFn(dialogState.data);
        console.log("executeAction: Action completed, setting success");
        setSuccess(true);
        return result;
      } catch (error) {
        console.log("executeAction: Error occurred", error);
        setError(error.message || "An error occurred");
        throw error;
      }
    },
    [dialogState.data, setLoading, setSuccess, setError]
  );

  return {
    dialogState,
    openDialog,
    closeDialog,
    setLoading,
    setSuccess,
    setError,
    executeAction,
  };
};

export default useConfirmDialog;
